import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgGenderMaleOutline = function SvgGenderMaleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10C6.23858 10 4 12.2386 4 15 4 17.7614 6.23858 20 9 20 11.7614 20 14 17.7614 14 15 14 12.2386 11.7614 10 9 10ZM2.5 15C2.5 11.4101 5.41015 8.5 9 8.5 12.5899 8.5 15.5 11.4101 15.5 15 15.5 18.5899 12.5899 21.5 9 21.5 5.41015 21.5 2.5 18.5899 2.5 15ZM14 3.75C14 3.33579 14.3358 3 14.75 3H20.25C20.6642 3 21 3.33579 21 3.75V9.25C21 9.66421 20.6642 10 20.25 10 19.8358 10 19.5 9.66421 19.5 9.25V4.5H14.75C14.3358 4.5 14 4.16421 14 3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0303 3.96967C20.3232 4.26256 20.3232 4.73744 20.0303 5.03033L13.7803 11.2803C13.4874 11.5732 13.0126 11.5732 12.7197 11.2803C12.4268 10.9874 12.4268 10.5126 12.7197 10.2197L18.9697 3.96967C19.2626 3.67678 19.7374 3.67678 20.0303 3.96967Z"
  })));
};

export { SvgGenderMaleOutline as ReactComponent };
//# sourceMappingURL=gender--male-outline.svg.js.map
